<template>
    <nav class="payment__nav payment__nav-half" role="navigation">
        <NavItem
            v-for="(option, index) in options.slice(0,5)"
            :key="index"
            :title="options.labels[option]"
            :name="option"
            v-bind="$attrs"
            :logo-name="option"
            :processing="state.processing"
            :backgroundProcessing="state.backgroundProcessing"
            @toggle-view-payments="emitToggleViewPayments"
            :active="currentPaymentOption === option"
            :index="index"
        />
        <button @click="$emit('show-all-menu')" type="button" class="payment__nav-more" :class="{hidden: options.length <= 5}">
            <span class="">{{translate("ui.payment.options.half", "See all payments options")}}</span>
            <svg
                width="10"
                height="16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 14.632L1.375 16l7.643-7.65L1.368.7 0 2.068 6.282 8.35 0 14.632z"
                    fill="#FF9B00"
                />
            </svg>
        </button>
    </nav>
</template>
<script>
import NavItem from "../nav-item";
import { ref, onBeforeUnmount } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";
export default {
    components: {
        NavItem,
    },
    emits: ["toggle-view-payments", "show-all-menu"],
    props: {
        options: {
            type: Array,
            required: true,
        },
        currentPaymentOption: {
            type: String,
            required: true,
        },
    },
    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        onBeforeUnmount(() => {
            subscription();
        });
        return { 
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
                backgroundProcessing: (state) => getValueFromPath(state, "backgroundProcessing") || false,
            }),
            checkoutData,
        };
    },

};
</script>